<template>
  <main class="main" id="main">
    <div class="top_line">
      <div class="container">
        <h1>Доставка бургеров</h1>
      </div>
    </div>
    <section class="section s-seo">
      <div class="container">
        <div class="seo_box">
          <div>
            <div class="line"></div>
            <p style="margin-top:2%;">Бургеры стали так популярны как в больших, так и  в маленьких городах, что почти догнали по количеству заказов пиццу. Признаемся, что американская еда сейчас не менее популярна, чем японская кухня или традиционная еропейская.</p>
            <p>Почему бургеры заказывают через сервис хочу-поесть.рф:</p>
            <p style="margin-top:2%;"> - Быстрая доставка для Вас или целой компании друзей.</p>
            <p> - Делая заказ бургеров прямо сейчас на нашем сайте Вы получаете реальный возврат бонусными рублями – 1 бонусный рубль равен 1 российскому рублю.</p>
            <p> - Вместе с бургерами Вы можете заказать напитки, <router-link to="/salad">салаты, </router-link><router-link to="/desert">десерты</router-link> и другую еду.</p>
            <p> - Вы можете накопить бонусные рубли и расплачиваться ими.</p>
            <p> - Мы постоянно проводим акции в наших социальных сетях.</p>
            <p> -  Мы проверяем рестораны на качество еды.</p>
            <p> - Если заказ очень понравился или наоборот нет, то можно оставить отзывы и заработать бонусные рубли на еду.</p>
            <p><br/><center><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/global/articles/burgers1.jpg" alt="Доставка бургеров" width="700" /></center></p>
            <p style="margin-top:2%;">Бургеры – это те самые сочные котлеты, салат, зелень, аппетитный соус и всевозможные добавки и все это в булочке с кунжутом. Вы любите с птицей, классические с телятиной или с кроликом? А может быть вегетарианские? Закажите Ваш любимый бургер на нашем сайте!</p>
            <router-link :to="'/product/25'" tag="div">
              <button class="menu_item_btn seo">ХОЧУ ПОЕСТЬ!</button>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'burger'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/burger.vue